import { useEffect, useMemo, useState } from "react";
import { ButtonTypes, ListData_ValueTypes } from "../../../../../Definitions";
import { LC_FEED_TIME, LCFeedTimeArgs, LCFeedTimeResponse } from "../../../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/lcFeedTime";
import { GenericDeviceTable } from "../../../../../Components/ToolsComponents/genericDeviceDataTable";
import ResetFeedTimesModal from "../../../../../Components/ToolsComponents/Modals/resetFeedTimesModal";
import NewButton from "../../../../../Components/BaseComponents/newButton";
import { glyphs } from "../../../../../Styles";
import ResetTableModal from "../../../../../Components/ToolsComponents/Modals/resetTableModal";
import { LC_TABLE_IDS } from "../../../../../Definitions/lcTableIds";
import { useAicoConnection } from "../../../../../Components";
import { useLazyQuery } from "@apollo/client";

const columnsData = [
	{ headerValue: "ID", accessor: "id", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "milestoneId", accessor: "milestoneId", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "feedcurveId", accessor: "feedcurveId", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "trigger", accessor: "trigger", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "state", accessor: "state", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "triggerValue", accessor: "triggerValue", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "day", accessor: "day", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "nday", accessor: "nday", type: ListData_ValueTypes.Number, sort: true },
	{ headerValue: "amount", accessor: "amount", type: ListData_ValueTypes.Number, sort: true },
]

export default function FeedTimeDataTable() {
	const [isResetTableModalOpen, setIsResetTableModalOpen] = useState<boolean>(false);

	const [isResetFeedTimesModalOpen, setIsResetFeedTimesModalOpen] = useState<boolean>(false);

	const { state: connectionState } = useAicoConnection();

	const [fetchData, { data, loading, error }] = useLazyQuery<LCFeedTimeResponse, LCFeedTimeArgs>(LC_FEED_TIME, { fetchPolicy: "network-only" });

	useEffect(() => {
		if (connectionState.deviceConnection) {
			fetchData({ variables: connectionState.deviceConnection });
		}
	}, [connectionState.deviceConnection]);

	const tableData = useMemo(() => {
		return data?.controller.lcFeedTime?.map((e, i) => ({
			...e,
			id: i
		})) ?? [];
	}, [data]);

	function handleCloseModal() {
		setIsResetFeedTimesModalOpen(false);
	}

	function handleOnSuccess() {
		if (connectionState.deviceConnection) {
			fetchData({ variables: connectionState.deviceConnection });
		}
	}

	return (
		<>
			<GenericDeviceTable
				title="Feed Times"
				columnsData={columnsData}
				data={tableData}
				loading={loading}
				error={error}
				onFetch={() => connectionState.deviceConnection && fetchData({ variables: connectionState.deviceConnection })}
				tabButtons={[
					<NewButton
						content="Reset Feeding Times"
						startEnhancer={glyphs.ArrowReset({})}
						onClick={() => {
							setIsResetFeedTimesModalOpen(true);
						}}
						buttonType={ButtonTypes.tableButton}
					/>,
					<NewButton
						key="Reset table"
						content="Reset Table"
						startEnhancer={glyphs.ArrowReset({})}
						onClick={() => {
							setIsResetTableModalOpen(true);
						}}
						buttonType={ButtonTypes.tableButton}
						disabled={!connectionState.deviceConnection}
					/>
				]}
			/>
			{connectionState.deviceConnection &&
				<>
					<ResetFeedTimesModal
						isModalOpen={isResetFeedTimesModalOpen}
						closeModal={handleCloseModal}
						onSuccess={handleOnSuccess}
					/>
					<ResetTableModal
						isModalOpen={isResetTableModalOpen}
						closeModal={() => { setIsResetTableModalOpen(false) }}
						onSuccess={handleOnSuccess}
						tableId={LC_TABLE_IDS.feedplanTimes}
					/>
				</>
			}
		</>
	)
}